// removed by extract-text-webpack-plugin
module.exports = {"heroContainer":"_3fvb1wYVG-ujxSW5vdEssJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/Chat.css
// module id = 289
// module chunks = 0